import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/selectedBlocks';

export const addSelectedBlock = createAction(types.ADD_SELECTED_BLOCK);
export const removeSelectedBlock = createAction(types.REMOVE_SELECTED_BLOCK);
export const selectAllBlocks = createAction(types.SELECT_ALL_BLOCKS);
export const removeAllSelectedBlocks = createAction(types.REMOVE_ALL_SELECTED_BLOCKS);
